export const PredicateIconClassNames = {
  LabelsCellAccount: 'labels-cell-account',
  LabelsCellMCC: 'labels-cell-mcc',
};
